"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPlan = void 0;
const Plan_1 = require("../../Domain/Plan");
const features_1 = require("../../features");
const limits_1 = require("../../limits");
// All features and limits should be set to false or 0 respectively
exports.CustomPlan = Plan_1.Plan.create(features_1.CademyFeatures, limits_1.CademyLimits, {
    id: 'custom',
    name: 'Enterprise',
    visible: true,
    pricing: null,
    features: {
        general: {
            customCertificates: false,
            scorm: false,
            privateDates: false,
            noteAttachments: false,
            importCourses: false,
        },
        marketplace: {
            hideProfile: false,
            hideCourses: false,
        },
        analytics: {
            monthlyAnalyticsEmails: false,
        },
        branding: {
            addYourBranding: false,
            customBrandColour: false,
            whitelabelling: false,
            customEmailDomain: false,
        },
        privacyAndSecurity: {
            restrictMinisite: false,
            sso: false,
            privateCourses: false,
        },
        payments: {
            invoiceCheckouts: true,
            manualPayments: true,
        },
        apps: {
            zapier: false,
        },
        ai: {
            courseGeneration: false,
        },
    },
    limits: {
        numberOfAdmins: {
            period: null,
            value: 0,
            kind: 'hard',
        },
        numberOfCourseInvites: {
            kind: 'hard',
            period: null,
            value: 0,
        },
        numberOfImportedBookings: {
            kind: 'hard',
            period: null,
            value: 0,
        },
        numberOfImportedOrders: {
            kind: 'hard',
            period: null,
            value: 0,
        },
        numberOfPublishedCourses: {
            kind: 'hard',
            period: null,
            value: 0,
        },
        maxFileUploadSize: {
            kind: 'hard',
            period: null,
            value: 0,
        },
        maxAgeOfForumPosts: {
            kind: 'hard',
            period: null,
            value: 0,
        },
        aiCredits: {
            kind: 'hard',
            period: null,
            value: 0,
        },
    },
});
